exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2 {\n  font-size: 1.2em;\n  font-weight: normal;\n  padding: .8em 1.5em 0 1.2em;\n  margin-bottom: .5em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/HeadingComponent/heading.component.scss
// module id = ./src/app/common/components/HeadingComponent/heading.component.scss
// module chunks = main